import * as React from "react";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";

interface Props {
  courseResource: CourseResource;
  userIsInUk: boolean;
}

const PreviewImage: React.FC<Props> = ({ courseResource, userIsInUk }) => {
  if (userIsInUk && courseResource.preview_headshot_alt_image_url) {
    return (
      <img
        src={courseResource.preview_headshot_alt_image_url}
        alt="headshot"
        className="headshot"
      />
    );
  }

  if (courseResource.preview_headshot_image_url) {
    return (
      <img
        src={courseResource.preview_headshot_image_url}
        alt="headshot"
        className="headshot"
      />
    );
  }

  return (
    <img
      src={require("../../../../../../../assets/images/courses/decal.png")}
      alt="headshot"
      className="decal"
    />
  );
};

export default PreviewImage;
